/* eslint-disable */

import { eventChannel, END } from 'redux-saga';
import { fork, all, takeEvery, put, call } from 'redux-saga/effects';
import _ from 'lodash';
import history from 'app/utils/history';
import { CLEAR_PROFILE_DATA, getProfile } from 'app/containers/Profile/redux';
import { getToken } from 'app/utils/user';
import {
  GET_LOGIN_CODE,
  GET_LOGIN_CODE_SUCCESS,
  GET_LOGIN_CODE_FAIL,
  CHECK_USER_LOGGEDIN,
  CHECK_USER_LOGGEDIN_SUCCESS,
  CHECK_USER_LOGGEDIN_FAIL,
  LOGOUT,
  LOGOUT_SUCCESS,
  LOGOUT_FAIL,
  CLEAR_LOGIN,
} from './redux';
import Request from 'app/utils/xhrWrapper';

let channel = null;

function checkLoginChannel() {
  return eventChannel(emitter => {
      const interval = setInterval(() => {
        const TOKEN = getToken() || '';
        emitter(TOKEN);
        if (TOKEN) {
          emitter(END);
        }
      }, 3000);
      return () => {
        clearInterval(interval);
      };
    },
  );
}

export function* getLoginCode() {
  yield takeEvery(GET_LOGIN_CODE, function* ({ data: { refrenceRoute, response: mockResponse } }) : any {
    yield put({ type: CLEAR_LOGIN });
    try {
      const response = mockResponse ? { data: { ...mockResponse } } : yield Request.get('user/Authenticate/get_verify_code?ref_type=tv');
      const responseData = _.get(response, ['data']);
      if (responseData) {
        yield put({ type: GET_LOGIN_CODE_SUCCESS, data: responseData });
        channel = yield call(checkLoginChannel);
        yield takeEvery(channel, function* (token) {
          if (token && history) {
            yield put(getProfile());
            history.push(refrenceRoute || `/${history.location.pathname.split('/')[1]}`, { backRoute: refrenceRoute ? refrenceRoute.replace('/w/', '/m/') : '' });
          } else {
            yield put({ type: CHECK_USER_LOGGEDIN, data: responseData.code });
          }
        });
      }
    } catch (error) {
      yield put({ type: GET_LOGIN_CODE_FAIL, data: error });
    }
  });
}

export function* checkUserLoggedin() {
  yield takeEvery(CHECK_USER_LOGGEDIN, function* ({ data }) : any {
    try {
      const response = yield Request.get(`user/Authenticate/sync_account_verify/code/${data}/ref_type/tv`);
      const responseData = _.get(response, ['data', 'attributes']);
      if (responseData && responseData.ltoken) {
        yield put({ type: CHECK_USER_LOGGEDIN_SUCCESS, data: responseData });
      } else {
        yield put({ type: CHECK_USER_LOGGEDIN_FAIL, data: {} });
      }
    } catch (error) {
      yield put({ type: CHECK_USER_LOGGEDIN_FAIL, data: error });
    }
  });
}

export function* clearLogin() {
  yield takeEvery(CLEAR_LOGIN, function* () : any {
    if (channel && channel.close) {
      channel.close();
    }
  });
}

export function* logout() {
  yield takeEvery(LOGOUT, function* ({ data }) : any {
    try {
      if (!_.get(data, 'skip')) {
        yield Request.get('user/Authenticate/signout');
      }
      yield put({ type: LOGOUT_SUCCESS });
      yield put({ type: CLEAR_PROFILE_DATA });
      if (history) {
        history.push(`/${history.location.pathname.split('/')[1]}`);
      }
    } catch (error) {
      yield put({ type: LOGOUT_FAIL });
    }
  });
}

export default function* () {
  yield all([
    fork(getLoginCode),
    fork(checkUserLoggedin),
    fork(logout),
    fork(clearLogin),
  ]);
}
